module.exports = __webpack_public_path__ + "static/media/green-eye-view-icon.5b429fb3.svg";